import { render } from "./FormPage.vue?vue&type=template&id=09b698b3"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__